import { useRef } from "react";
import { FiPlus } from "react-icons/fi";

export default function StartVerification({ onUpload }) {
    const fileRef = useRef(null);

    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (file && onUpload) {
            onUpload(file);
        }
    };

    return (
        <div className="flex flex-col items-center text-center px-4">

            <div className="flex flex-col items-center text-center px-4">
                {/* Sample Image */}
                <div className="w-[250px] h-[220px] rounded-2xl overflow-hidden mb-3">
                    <img
                        src="./images/sample_aadhar.png"
                        alt="Sample"
                        className="w-full h-full object-cover"
                    />
                </div>

                <span className="text-green-400 text-sm mb-6">
                    Sample Photo
                </span>

                {/* Text */}
                <h2 className="text-white text-xl font-semibold mb-2">
                    Upload Photo
                </h2>
                <p className="text-gray-400 text-xs max-w-sm mb-8">
                    Make sure the front side of your ID and your face are clearly visible.
                </p>

                {/* Upload Button */}
                <button
                    onClick={() => fileRef.current.click()}
                    className="flex items-center gap-2 px-10 py-3 rounded-full 
                               border border-red-500 text-white
                               transition"
                >
                    <FiPlus className="text-lg" />
                    Upload Photo
                </button>

                <input
                    type="file"
                    accept="image/*"
                    ref={fileRef}
                    onChange={handleFileSelect}
                    className="hidden"
                />
            </div>
        </div>
    );
}